export default __webpack_public_path__ + "static/media/news6.2a45abfd.jpg";